import ReactDOM from 'react-dom';
import { X } from 'lucide-react';

interface ProcessedLeadModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ProcessedLeadModal({ isOpen, onClose }: ProcessedLeadModalProps) {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full" onClick={(e) => e.stopPropagation()}>
        <div className="border-b border-gray-200 px-8 py-6 flex items-center justify-between rounded-t-2xl">
          <h2 className="text-2xl font-extrabold text-[#05E0D1] tracking-tight font-display">Processed Lead Definition</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-6 h-6 text-gray-500" />
          </button>
        </div>

        <div className="p-8">
          <p className="text-xl font-extrabold text-gray-900 tracking-tight font-display mb-6 text-center">
            Generated, enriched & verified — then reached out through all valid channels.
          </p>
          <p className="text-gray-700 leading-relaxed">
            A processed lead is a lead your AI agents have researched, verified, and attempted to contact through Call, WhatsApp, Email, and LinkedIn.
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
}
